"use strict";
// _partialFile.js

{
  // ハンバーガーメニュー
  document.addEventListener("DOMContentLoaded", () => {
    //定義
    const drawerIcon =
      document.querySelector(".l-spContainer .p-drawer__icon") ||
      document.querySelector(".p-drawer__icon");
    const drawerBtnClose = document.querySelector(".p-drawer__btnClose");
    const drawer = document.querySelector(".p-drawer");
    /**
     * 葬儀トップを「同じフォルダ内の top / index.html」で同一視する。
     */
    const sougiRootKey = (pathname) => {
      const raw = (pathname || "").replace(/\/+$/, "") || "/";
      const segments = raw.split("/").filter(Boolean);
      const last = segments.length ? segments[segments.length - 1].toLowerCase() : "";

      if (raw === "/") {
        return "__sougi__::root";
      }
      if (last === "top" || last === "index.html") {
        const parentKey = segments
          .slice(0, -1)
          .map((s) => s.toLowerCase())
          .join("/");
        return parentKey ? `__sougi__::${parentKey}` : "__sougi__::root";
      }
      return raw;
    };

    /** クリック時に同一ページ内のハッシュ遷移として扱うか */
    const isSamePageHashNav = (hrefAttr) => {
      try {
        const url = new URL(hrefAttr, location.href);
        if (!url.hash || url.hash === "#") return false;
        return sougiRootKey(location.pathname) === sougiRootKey(url.pathname);
      } catch {
        return false;
      }
    };

    const resolveHashTarget = (hash) => {
      const id = decodeURIComponent(String(hash).replace(/^#/, ""));
      if (!id) return null;
      return document.getElementById(id);
    };

    const drawerNavItem = document.querySelectorAll('.p-drawer__body a[href*="#"]');
    const headerEl = document.querySelector(".p-header");
    const headerHeight = headerEl ? headerEl.offsetHeight : 0;
    const breakpoint = 768;
    let isMenuOpen = false;
    let isMenuOpenAtBreakpoint = false;

    if (!drawerIcon || !drawer) return;

    //メニューを開くアニメーション
    const openMenu = () => {
      if (!drawer.classList.contains("js-show")) {
        drawer.classList.add("js-show");
        drawerIcon.classList.add("js-show");
      }
    };

    //メニューを閉じるアニメーション
    const closeMenu = () => {
      if (drawer.classList.contains("js-show")) {
        drawer.classList.remove("js-show");
        drawerIcon.classList.remove("js-show");
        isMenuOpen = false;
      }
    };

    //メニューの開閉動作
    const toggleMenu = () => {
      if (!drawer.classList.contains("js-show")) {
        openMenu();
      } else {
        closeMenu();
      }
    };

    //リサイズ処理
    const handleResize = () => {
      const bp = breakpoint;
      const windowWidth = window.innerWidth;
      if (windowWidth > bp && isMenuOpenAtBreakpoint) {
        closeMenu();
      } else if (windowWidth <= bp && drawer.classList.contains("js-show")) {
        isMenuOpenAtBreakpoint = true;
      }
    };

    //メニュー外クリック処理
    const clickOuter = (event) => {
      if (drawer.classList.contains("js-show") && !drawer.contains(event.target) && isMenuOpen) {
        closeMenu();
      } else if (drawer.classList.contains("js-show") && !drawer.contains(event.target)) {
        isMenuOpen = true;
      }
    };

    //該当箇所までスクロール
    const linkScroll = (target) => {
      if (target) {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - headerHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    };

    drawerIcon.addEventListener("click", toggleMenu);
    if (drawerBtnClose) {
      drawerBtnClose.addEventListener("click", () => {
        closeMenu();
      });
    }
    //画面幅リサイズ時
    window.addEventListener("resize", handleResize);
    //メニュー外クリック時
    document.addEventListener("click", clickOuter);
    //ページ内リンクナビメニュー クリック時（#foo / index.html#foo など）
    drawerNavItem.forEach((item) => {
      item.addEventListener("click", (event) => {
        const href = item.getAttribute("href");
        if (!href || href.startsWith("tel:") || href.startsWith("mailto:")) {
          return;
        }
        if (!isSamePageHashNav(href)) {
          return;
        }
        let hash = "";
        try {
          hash = new URL(href, location.href).hash;
        } catch {
          return;
        }
        const targetItem = resolveHashTarget(hash);
        if (!targetItem) {
          return;
        }
        event.preventDefault();
        closeMenu();
        linkScroll(targetItem);
      });
    });
  });
}
